import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { EVENT_LOGIN_REDIRECT } from './constants/constants';
import storage from './helpers/storage';
import { redirectionRoutes } from './routes/redirectionRoutes';


const RedirectLogin: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        // event from interceptor to move to login
        document.addEventListener(EVENT_LOGIN_REDIRECT, () => {
            navigate(redirectionRoutes.login.path, {replace: true});
        });
        const token: string | null = storage.getToken();
        const isPublicUrl = [redirectionRoutes.login.path, redirectionRoutes.createAccount.path, redirectionRoutes.forgotPassword.path, redirectionRoutes.resetPasswordWithoutToken.path, redirectionRoutes.setupPassword.path, redirectionRoutes.verifyAccountWithoutToken.path, redirectionRoutes.twoFactorAuthentication.path, redirectionRoutes.scanOTPRequest.path].some((url: string) => location.pathname.includes(url))
        if (token === null && !isPublicUrl) {
            navigate(redirectionRoutes.login.path, { replace: true });
        }
    }, []);

    return null; // This component doesn't render anything
};

export default RedirectLogin;
